import { render, staticRenderFns } from "./ExternalIdsForm.vue?vue&type=template&id=c46d4de2&"
import script from "./ExternalIdsForm.vue?vue&type=script&lang=js&"
export * from "./ExternalIdsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports